export default __webpack_public_path__ + "static/media/Gate.8200be69.svg";